module.exports = __webpack_public_path__ + "media/conversa/ico_sofia30_-ab8a0ef2.png";